export default __webpack_public_path__ + "static/media/nobel-pic-2.53047801.png";